export default __webpack_public_path__ + "static/notification-sound-5b9ecb195741da638d9c555e72e0f041.wav";